<script>
    import { Modal, ModalHeader, ModalBody } from 'sveltestrap';
    import { fade } from 'svelte/transition';
    import http from '../api/http';
    import SvelteMarkdown from 'svelte-markdown';

    let whatsNew = "There was a problem loading the release notes. Please try again later.";
    export let shown = false;

    export const show = () => {
        shown = true;
    }

    const getWhatsNew = async () => {
        const result = await http.get(window.apiBaseUrl + '/deploy/dashboard/system/whatsnew');
        if (result.status == 200) {
            whatsNew = await result.text();
        }
        return whatsNew;
    }

    const toggle = () => {
        shown = !shown;
    }
</script>

<div class="{shown ? 'modal fade show' : 'modal fade'}" tabindex="-1" role="dialog" style="{shown ? 'display: block; padding-right: 17px;' : 'display: none;'}" aria-modal="{shown ? 'true' : null}" aria-hidden="{shown ? null : 'true'}">
    <div class="modal-dialog wn-modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content wn-modal-content">
            <div class="modal-header">
                <h5 class="modal-title">What's New?</h5>
                <button on:click={() => toggle()} type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body wn-modal-body">
                {#await getWhatsNew()}
                    <div class="text-center">
                        <div class="spinner-border text-info" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                {:then}
                    <div transition:fade>
                        <SvelteMarkdown source={whatsNew} />
                    </div>
                {/await}
            </div>
            <div class="modal-footer">
                <button on:click={() => toggle()} class="btn btn-primary btn-plus btn-icon-split float-right">
                    <span class="icon text-white-50">
                        <i class="fas fa-check"></i>
                    </span>
                    <span class="text">Done</span>
                </button>
            </div>
        </div>
    </div>
</div>

<style>
.wn-modal-dialog,
.wn-modal-content {
    height: 80%;
}

.wn-modal-body {
    max-height: calc(100% - 120px);
    overflow-y: scroll;
}    
</style>